import { ContractBalance } from '@/features/invoices/api/use-get-saldo';

export function calculateSaldo(records?: ContractBalance[]): number {
  return records?.reduce((sum, record) => sum + record.amount, 0);
}
